import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import GeneralForm from '@components/Document/Forms/General';
import ContentLinkForm from '@components/Document/Forms/ContentLink';
import ContentDocument from '@components/Document/Forms/ContentDocument';
import ContentTexForm from '@components/Document/Forms/ContentText';
import ObligatoryForm from '@components/Document/Forms/Obligatory';
import VisibilityForm from '@components/Document/Forms/Visibility';
import PreviewForm from '@components/Document/Forms/Preview';
import LoadingAction from '@components/LoadingAction';



import { CLEAR_VALUES_DOCUMENT } from '@constants/actionType'
import { TypeDocuments } from '@constants/documents'
import { AuthorizedStatusSend, LANGUAGE_DEFAULT } from '@constants/general'

import { addDocument } from '@actions/documents';
import { sendActionToBitacora  } from '@actions/bitacora';

import store from '@store'

class StepsNewDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      maxStep:0,
      btnSubmitLoading: false,
      typeDocumentOrigin: '',
      loadingPage: true,
      loadingAction: false,
    };
  }

  async componentDidMount() {
    const { history, t } = this.props
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_DOCUMENT,
      })
    }
    this.setState({loadingPage: false})
  }

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  nexStep = async (data) => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    if (step === 0) await this.validateMaxStepEditComponents()
    if (step === 2) return this.createNewDocument('pending')
    // const validateMaxStep = step + 1 > maxStep ? step + 1 : maxStep
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = (data) => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  createNewDocument = async (estatus, justification) => {
    const { history, t, addDocument, sendActionToBitacora, _general } = this.props
    this.setState({ loadingAction: true, btnSubmitLoading: true });
    const response = await addDocument(estatus)
    if (!response.status) {
      const { transactionNameOpt } = this.state
      const dataBitacora = {
        transactionName: transactionNameOpt || 'Documento',
        reason: `${_general[LANGUAGE_DEFAULT].name} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.setState({ loadingAction: false, btnSubmitLoading: false });
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/documents'),
        onHide: () => history.push('/documents')
      });
    }
    return this.setState({ loadingAction: false, btnSubmitLoading: false });
  }

  saveNewDocument = (justification) => {
    this.setState({transactionNameOpt: 'altaDocumento'}, () => {
      this.createNewDocument(AuthorizedStatusSend.STATUS_EDITION, justification)
    })
  }

  saveAndAutorized = (justification) => {
    this.setState({transactionNameOpt: 'autDocumento'}, () => {
      this.createNewDocument(AuthorizedStatusSend.STATUS_AUTHORIZED, justification)
    })
  }

  saveAndSendAuthorized = (justification) => {
    this.setState({transactionNameOpt: 'envAutDocumento'}, () => {
      this.createNewDocument(AuthorizedStatusSend.STATUS_PENDING, justification)
    })
  }

  validateMaxStepEditComponents = () => {
    const { typeDocumentOrigin } = this.state
    const { _general } = this.props
    if (!typeDocumentOrigin) this.setState({typeDocumentOrigin: _general.typeDocument})
    else if (_general?.typeDocument !== typeDocumentOrigin) {
      this.setState({maxStep: 1, typeDocumentOrigin: _general.typeDocument})
    }
  }

  render() {
    const { step, btnSubmitLoading, loadingPage } = this.state;
    const { t, _document } = this.props;

    const steps = [
      { label: t("Datos generales"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Contenido"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Obligatoriedad"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Visibilidad"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Vista Previa"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const stepsRender = () => {
      if (step === 0) {
        return (
          <GeneralForm
            success={this.nexStep}
            // onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (step === 1) {
        if (_document.general.typeDocument === TypeDocuments.IS_LINK) {
          return (
            <ContentLinkForm
              // success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}

              success={this.saveNewDocument}
              authorize={this.saveAndAutorized}
              sendAuthorize={this.saveAndSendAuthorized}
            />
          )
        }
        if (_document.general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF) {
          return (
            <ContentDocument
              // success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}

              success={this.saveNewDocument}
              authorize={this.saveAndAutorized}
              sendAuthorize={this.saveAndSendAuthorized}
            />
          )
        }
        if (_document.general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT) {
          return (
            <ContentTexForm
            //   success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}

              success={this.saveNewDocument}
              authorize={this.saveAndAutorized}
              sendAuthorize={this.saveAndSendAuthorized}
            />
          );
        }
      }
      if (step === 2) {
        return (
          <ObligatoryForm
            success={this.saveNewDocument}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}

            authorize={this.saveAndAutorized}
            sendAuthorize={this.saveAndSendAuthorized}
          />
        );
      }
      // if (step === 3) {
      //   return (
      //     <VisibilityForm
      //       success={this.nexStep}
      //       authorize={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (step === 4) {
      //   return (
      //     <PreviewForm
      //       success={this.nexStep}
      //       authorize={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }

      return true;
    };

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos del documento")} linkText={t("Ir al listado")} to="/documents" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>

            {stepsRender()}
          </div>
        </div>
        { this.state.loadingAction && <LoadingAction/> }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  languagesCatalog: state.catalogs.languagesCatalog,
  _general: state.document.general,

  _keysLenguages: state.catalogs.keysLenguages,
  _document: state.document,
});

const mapDispatchToProps = {
  addDocument,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(StepsNewDocument);
